import type { WorkspaceSearchFull } from '../../types/index.js';
import { safeJsonDateRequired } from './date.js';

function normalizeSearchResult<T extends { createdOn: string }>(data: T): Omit<T, 'createdOn'> & { createdOn: Date } {
  return {
    ...data,
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}

function normalizeResults<T extends { items: { createdOn: string }[] }>(data: T): (Omit<T, 'items'> & { items: (Omit<T['items'][number], 'createdOn'> & { createdOn: Date })[] }) | null {
  if (!data) return null;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  return { ...data, items: data.items.map(normalizeSearchResult) } as any;
}

export function normalizeSearchFullFileResults(data: WorkspaceSearchFull.File.Results<string>): WorkspaceSearchFull.File.Results | null {
  return normalizeResults(data);
}

export function normalizeSearchFullFolderResults(data: WorkspaceSearchFull.Folder.Results<string>): WorkspaceSearchFull.Folder.Results | null {
  return normalizeResults(data);
}

export function normalizeSearchFullBrandResults(data: WorkspaceSearchFull.Brand.Results<string>): WorkspaceSearchFull.Brand.Results | null {
  return normalizeResults(data);
}

export function normalizeSearchFullDashboardResults(data: WorkspaceSearchFull.Dashboard.Results<string>): WorkspaceSearchFull.Dashboard.Results | null {
  return normalizeResults(data);
}

export function normalizeSearchFullQuantAnalysesResults(data: WorkspaceSearchFull.QuantAnalyses.Results<string>): WorkspaceSearchFull.QuantAnalyses.Results | null {
  return normalizeResults(data);
}

export function normalizeSearchFullProjectResults(data: WorkspaceSearchFull.Project.Results<string>): WorkspaceSearchFull.Project.Results | null {
  return normalizeResults(data);
}

export function normalizeSearchFullTranscriptResults(data: WorkspaceSearchFull.Transcript.Results<string>): WorkspaceSearchFull.Transcript.Results | null {
  return normalizeResults(data);
}
